import { FunctionComponent, PropsWithChildren, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { User } from '../../../../Models/User/User';
import AuthenticatedRouteSelectors from '../../../../Modules/Redux/Components/AuthenticatedRoute/AuthenticatedRouteSelectors';
import { Optional, TwitchToken } from '../../../../Utils/Types';

export const AuthenticatedRoute: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const twitchToken: Optional<TwitchToken> = useSelector(AuthenticatedRouteSelectors.twitchToken);
  const currentUser: Optional<User> = useSelector(AuthenticatedRouteSelectors.currentUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser || !twitchToken) {
      navigate('/');
    }
  }, [twitchToken, currentUser]);

  return <>{children}</>;
};
